import React, { lazy } from 'react';
import { RouteProps } from 'react-router-dom';
import {
	componentPagesMenu,
	dashboardPagesMenu,
	demoPagesMenu,
	gettingStartedPagesMenu,
	pageLayoutTypesPagesMenu,
	settingPageMenu,
} from '../menu';
import Login from '../pages/presentation/auth/Login';
import ForgotPassword from '../pages/presentation/auth/ForgotPassword';
import ChangePassword from '../pages/presentation/auth/ChangePassword';
import ResetPassword from '../pages/presentation/auth/ResetPassword';
import UpdateCompanyProfile from '../pages/presentation/UpdateProfile/UpdateCompanyProfile';
import PrivacyPolicy from '../pages/presentation/Policy/PrivacyPolicy';
import TermsAndCondition from '../pages/presentation/Policy/TermsAndCondition';
import DeleteDataPage from '../pages/presentation/DeleteData/DeleteData';

const LANDING = {
	DASHBOARD: lazy(() => import('../pages/presentation/dashboard/DashboardPage')),
};

const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};

const PAGE_LAYOUTS = {
	ASIDE: lazy(() => import('../pages/presentation/aside-types/DefaultAsidePage')),
	MINIMIZE_ASIDE: lazy(() => import('../pages/presentation/aside-types/MinimizeAsidePage')),
};

const ANALYTIC_PAGE = {
	ANALYTIC_PAGE: lazy(() => import('../pages/presentation/Analytics/Analytics')),
};

const ROLE_PAGE = {
	ROLE_PAGE: lazy(() => import('../pages/presentation/RoleAndPermission/ROLE/index')),
};

const PERMISSION_PAGE = {
	PERMISSION_PAGE: lazy(
		() => import('../pages/presentation/RoleAndPermission/PERMISSION/Permission'),
	),
};

const PERMISSION_ALLOCATION_PAGE = {
	PERMISSION_ALLOCATION_PAGE: lazy(
		() => import('../pages/presentation/RoleAndPermission/ALLOCATION/Allocation'),
	),
};

const ACCOUNT_PAGE = {
	ACCOUNT_PAGE: lazy(() => import('../pages/presentation/Account')),
};

const ACCOUNT_ADD_PAGE = {
	ACCOUNT_ADD_PAGE: lazy(() => import('../pages/presentation/Account/Create')),
};

const ACCOUNT_DETAIL_PAGE = {
	ACCOUNT_DETAIL_PAGE: lazy(() => import('../pages/presentation/Account/Details')),
};

const PRODUCT_PAGE = {
	PRODUCT_PAGE: lazy(() => import('../pages/presentation/Product')),
};

const PRODUCT_ADD_PAGE = {
	PRODUCT_ADD_PAGE: lazy(() => import('../pages/presentation/Product/Create')),
};

const PRODUCT_DETAIL_PAGE = {
	PRODUCT_DETAIL_PAGE: lazy(() => import('../pages/presentation/Product/Details')),
};

const PURCHASE_PAGE = {
	PURCHASE_PAGE: lazy(() => import('../pages/presentation/PurchaseBill')),
};

const PURCHASE_ADD_PAGE = {
	PURCHASE_ADD_PAGE: lazy(() => import('../pages/presentation/PurchaseBill/Create')),
};

const PURCHASE_DETAIL_PAGE = {
	PURCHASE_DETAIL_PAGE: lazy(() => import('../pages/presentation/PurchaseBill/Details')),
};

const PRODUCT_CATEGORY_PAGE = {
	PRODUCT_CATEGORY_PAGE: lazy(() => import('../pages/presentation/ProductCategory')),
};

const PRODUCT_CATEGORY_ADD_PAGE = {
	PRODUCT_CATEGORY_ADD_PAGE: lazy(() => import('../pages/presentation/ProductCategory/Create')),
};

const PRODUCT_UNIT_PAGE = {
	PRODUCT_UNIT_PAGE: lazy(() => import('../pages/presentation/ProductUnit')),
};

const PRODUCT_UNIT_ADD_PAGE = {
	PRODUCT_UNIT_ADD_PAGE: lazy(() => import('../pages/presentation/ProductUnit/Create')),
};

const DEVICE_PAGE = {
	DEVICE_LIST_PAGE: lazy(() => import('../pages/presentation/Device/Device')),
	DEVICE_CREATE_PAGE: lazy(() => import('../pages/presentation/Device/Create')),
	DEVICE_DEATIL_PAGE: lazy(() => import('../pages/presentation/Device/Detail')),
};

const DEVICE_USER_PAGE = {
	DEVICE_USER_LIST_PAGE: lazy(() => import('../pages/presentation/DeviceUser/DeviceUser')),
	DEVICE_USER_CREATE_PAGE: lazy(() => import('../pages/presentation/DeviceUser/Create')),
};

const STAFF_SALARY_PAGE = {
	STAFF_SALARY_LIST_PAGE: lazy(
		() => import('../pages/presentation/HRM/SalaryManagement/SalaryManagement'),
	),
	STAFF_SALARY_CREATE_PAGE: lazy(
		() => import('../pages/presentation/HRM/SalaryManagement/Create'),
	),
	STAFF_SALARY_DETAILS_PAGE: lazy(
		() => import('../pages/presentation/HRM/SalaryManagement/Details'),
	),
};
const NOTIFICATION_PAGE = {
	NOTIFICATION_LIST_PAGE: lazy(() => import('../pages/presentation/Notification/Notification')),
	NOTIFICATION_CREATE_PAGE: lazy(() => import('../pages/presentation/Notification/Create')),
};
const CONTRACT_MANAGEMENT_PAGE = {
	CONTRACT_MANAGEMENT_LIST_PAGE: lazy(
		() => import('../pages/presentation/ContractManagement/ContractManagement'),
	),
	CONTRACT_MANAGEMENT_CREATE_PAGE: lazy(
		() => import('../pages/presentation/ContractManagement/Create'),
	),
	CONTRACT_MANAGEMENT_DETAIL_PAGE: lazy(
		() => import('../pages/presentation/ContractManagement/Detail'),
	),
	CONTRACT_EXPIRING_PAGE: lazy(
		() => import('../pages/presentation/ContractManagement/ExpiringAMC'),
	),
	CONTRACT_EXPIRED_PAGE: lazy(
		() => import('../pages/presentation/ContractManagement/ExpiredAMC'),
	),
};

const AREA_PAGE = {
	AREA_LIST_PAGE: lazy(() => import('../pages/presentation/Area/Area')),
	AREA_CREATE_PAGE: lazy(() => import('../pages/presentation/Area/Create')),
};

const COMPANY_PAGE = {
	COMPANY_LIST_PAGE: lazy(() => import('../pages/presentation/Company/Company')),
	COMPANY_CREATE_PAGE: lazy(() => import('../pages/presentation/Company/Create')),
	COMPANY_DETAIL_PAGE: lazy(() => import('../pages/presentation/Company/Details')),
};
const VERIFICATION_PAGE = {
	VERIFICATION_LIST_PAGE: lazy(() => import('../pages/presentation/VerificationProcess')),
	REQUISITION_PAGE: lazy(() => import('../pages/presentation/VerificationProcess/Requisition')),
	PURCHASE_INDENT_PAGE: lazy(
		() => import('../pages/presentation/VerificationProcess/PurchaseIndent'),
	),
	PURCHASE_ORDER_PAGE: lazy(
		() => import('../pages/presentation/VerificationProcess/PurchaseOrder'),
	),
	PURCHASE_BILL_PAGE: lazy(
		() => import('../pages/presentation/VerificationProcess/PurchaseBill'),
	),
	CHEQUE_SIGNATURE: lazy(
		() => import('../pages/presentation/VerificationProcess/ChequeSignature'),
	),
};
const STAFF_PAGE = {
	STAFF_LIST_PAGE: lazy(() => import('../pages/presentation/Staff/Staff')),
	STAFF_CREATE_PAGE: lazy(() => import('../pages/presentation/Staff/Create')),
	STAFF_DETAIL_PAGE: lazy(() => import('../pages/presentation/Staff/Details')),
};

const PURCHASE_INDENT_PAGE = {
	PURCHASE_INDENT_PAGE: lazy(() => import('../pages/presentation/PurchaseIndent')),
};

const PURCHASE_CONFIRM_INDENT_PAGE = {
	PURCHASE_CONFIRM_INDENT_PAGE: lazy(() => import('../pages/presentation/PurchaseIndent')),
};

const PURCHASE_INDENT_ADD_PAGE = {
	PURCHASE_INDENT_ADD_PAGE: lazy(() => import('../pages/presentation/PurchaseIndent/Create')),
};

const PURCHASE_INDENT_DETAIL_PAGE = {
	PURCHASE_INDENT_DETAIL_PAGE: lazy(() => import('../pages/presentation/PurchaseIndent/Details')),
};

const PURCHASEORDER_PAGE = {
	PURCHASEORDER_PAGE: lazy(() => import('../pages/presentation/PurchaseOrder')),
};

const PURCHASEORDER_ADD_PAGE = {
	PURCHASEORDER_ADD_PAGE: lazy(() => import('../pages/presentation/PurchaseOrder/Create')),
};

const PURCHASEORDER_DETAIL_PAGE = {
	PURCHASEORDER_DETAIL_PAGE: lazy(() => import('../pages/presentation/PurchaseOrder/Details')),
};
const PURCHASEORDERREQUEST_PAGE = {
	PURCHASEORDERREQUEST_PAGE: lazy(() => import('../pages/presentation/PurchaseOrderRequest')),
};
const PAYMENT_PAGE = {
	PAYMENT_LIST_PAGE: lazy(() => import('../pages/presentation/Payment')),
	PAYMENT_CREATE_PAGE: lazy(() => import('../pages/presentation/Payment/Create')),
	PAYMENT_DETAIL_PAGE: lazy(() => import('../pages/presentation/Payment/Details')),
};
const SITE_VERIFICATION_CHECKLIST_PAGE = {
	SITE_VERIFICATION_CHECKLIST_LIST_PAGE: lazy(
		() =>
			import(
				'../pages/presentation/QCSiteVerification/SiteVerificationChecklist/SiteVerificationChecklist'
			),
	),
	SITE_VERIFICATION_CHECKLIST_CREATE_PAGE: lazy(
		() => import('../pages/presentation/QCSiteVerification/SiteVerificationChecklist/Create'),
	),
	SITE_VERIFICATION_CHECKLIST_UPDATE_PAGE: lazy(
		() => import('../pages/presentation/QCSiteVerification/SiteVerificationChecklist/Create'),
	),
};

const SITE_MANAGEMENT_PAGE = {
	SITE_MANAGEMENT_LIST_PAGE: lazy(
		() => import('../pages/presentation/SiteManagement/SiteManagement'),
	),
	SITE_MANAGEMENT_CREATE_PAGE: lazy(() => import('../pages/presentation/SiteManagement/Create')),
	SITE_MANAGEMENT_UPDATE_PAGE: lazy(() => import('../pages/presentation/SiteManagement/Create')),
	SITE_MANAGEMENT_DETAIL_PAGE: lazy(() => import('../pages/presentation/SiteManagement/Details')),
	SITE_MANAGEMENT_SUMMARY_PAGE: lazy(
		() => import('../pages/presentation/SiteManagement/Summary'),
	),
};
const SITE_MANAGEMENT_STRUCTURE_PAGE = {
	SITE_MANAGEMENT_STRUCTURE_LIST_PAGE: lazy(
		() =>
			import('../pages/presentation/HRM/SalaryStructureManagement/SalaryStructureManagement'),
	),
	SITE_MANAGEMENT_STRUCTURE_CREATE_PAGE: lazy(
		() => import('../pages/presentation/HRM/SalaryStructureManagement/Create'),
	),
	SITE_MANAGEMENT_STRUCTURE_UPDATE_PAGE: lazy(
		() => import('../pages/presentation/HRM/SalaryStructureManagement/Create'),
	),
	SITE_MANAGEMENT_STRUCTURE_DETAIL_PAGE: lazy(
		() => import('../pages/presentation/HRM/SalaryStructureManagement/Details'),
	),
};

const SALARY_INCREMENT_PAGE = {
	SALARY_INCREMENT_LIST_PAGE: lazy(
		() =>
			import('../pages/presentation/HRM/SalaryIncrement'),
	),
};

const SITE_VERIFICATION_PAGE = {
	SITE_VERIFICATION_LIST_PAGE: lazy(
		() => import('../pages/presentation/QCSiteVerification/SiteVerification/SiteVerification'),
	),
	SITE_VERIFICATION_CREATE_PAGE: lazy(
		() => import('../pages/presentation/QCSiteVerification/SiteVerification/Create'),
	),
	SITE_VERIFICATION_UPDATE_PAGE: lazy(
		() => import('../pages/presentation/QCSiteVerification/SiteVerification/Create'),
	),
	SITE_VERIFICATION_DETAIL_PAGE: lazy(
		() => import('../pages/presentation/QCSiteVerification/SiteVerification/Details'),
	),
};

const PAYMENT_TERMS_PAGE = {
	PAYMENT_TERMS_LIST_PAGE: lazy(() => import('../pages/presentation/PaymentTerms/index')),
	PAYMENT_TERMS_CREATE_PAGE: lazy(() => import('../pages/presentation/PaymentTerms/Create')),
	PAYMENT_TERMS_DETAIL_PAGE: lazy(() => import('../pages/presentation/PaymentTerms/Details')),
};
const PAYMENT_VERIFICATION_PAGE = {
	PAYMENT_VERIFICATION_CREATE_PAGE: lazy(
		() => import('../pages/presentation/PaymentVerification/Create'),
	),
	PAYMENT_VERIFICATION_DETAIL_PAGE: lazy(
		() => import('../pages/presentation/PaymentVerification/Detail'),
	),
	PAYMENT_VERIFICATION_LIST_PAGE: lazy(
		() => import('../pages/presentation/PaymentVerification/Verification'),
	),
};
const PAYMENT_STEPS_PAGE = {
	PAYMENT_STEPS_LIST_PAGE: lazy(() => import('../pages/presentation/PaymentSteps/index')),
	PAYMENT_STEPS_CREATE_PAGE: lazy(() => import('../pages/presentation/PaymentSteps/Create')),
	// PAYMENT_STEPS_DETAIL_PAGE: lazy(() => import('../pages/presentation/PaymentSteps/Details')),
};

const SETTINGS_PAGE = {
	ROLE_PAGE: lazy(() => import('../pages/presentation/Settings/Staff/Role')),
};
const UPDATE_PROFILE_PAGE = {
	UPDATE_PROFILE_PAGE: lazy(() => import('../pages/presentation/UpdateProfile/UpdateProfile')),
};

const PLACE_OF_SUPPLY_PAGE = {
	PLACE_OF_SUPPLY_PAGE: lazy(() => import('../pages/presentation/PlaceOfSupply')),
	PLACE_OF_SUPPLY_CREATE_PAGE: lazy(() => import('../pages/presentation/PlaceOfSupply/Create')),
};

const PAYMENT_TYPE_PAGE = {
	PAYMENT_TYPE_PAGE: lazy(() => import('../pages/presentation/PaymentType')),
};

const PAYMENT_TYPE_CREATE_PAGE = {
	PAYMENT_TYPE_CREATE_PAGE: lazy(() => import('../pages/presentation/PaymentType/Create')),
};
const REQUISTION_PAGE = {
	REQUISTION_LIST_PAGE: lazy(() => import('../pages/presentation/Requisition')),
	REQUISTION_DETAIL_PAGE: lazy(() => import('../pages/presentation/Requisition/Details')),
	REQUISTION_CREATE_PAGE: lazy(() => import('../pages/presentation/Requisition/Create')),
};

const GRN_PAGE = {
	GRN_LIST_PAGE: lazy(() => import('../pages/presentation/GRN')),
	GRN_DETAIL_PAGE: lazy(() => import('../pages/presentation/GRN/Details')),
	GRN_CREATE_PAGE: lazy(() => import('../pages/presentation/GRN/Create')),
};
const QUOTATION_PAGE = {
	QUOTATION_LIST_PAGE: lazy(() => import('../pages/presentation/Quotation')),
	QUOTATION_CREATE_PAGE: lazy(() => import('../pages/presentation/Quotation/Create')),
	QUOTATION_DETAIL_PAGE: lazy(() => import('../pages/presentation/Quotation/Details')),
};

const HOLIDAY_PAGE = {
	HOLIDAY_LIST_PAGE: lazy(() => import('../pages/presentation/HRM/HolidayManagement')),
	HOLIDAY_CREATE_PAGE: lazy(() => import('../pages/presentation/HRM/HolidayManagement/Create')),
	HOLIDAY_DETAIL_PAGE: lazy(() => import('../pages/presentation/HRM/HolidayManagement/Details')),
};
const SHIFT_MANAGEMENT_PAGE = {
	SHIFT_LIST_PAGE: lazy(() => import('../pages/presentation/HRM/ShiftManagement')),
	SHIFT_CREATE_PAGE: lazy(() => import('../pages/presentation/HRM/ShiftManagement/Create')),
};

const MODIFY_PURCHASEORDER_PAGE = {
	MODIFY_PURCHASEORDER_PAGE: lazy(() => import('../pages/presentation/ModifyPurchaseOrder')),
	MODIFY_PO_REQUEST_LIST_PAGE: lazy(() => import('../pages/presentation/ModifyPurchaseOrder/POModReq')),
	MODIFY_PURCHASEORDER_DETAIL_PAGE: lazy(
		() => import('../pages/presentation/ModifyPurchaseOrder/Details'),
	),
	MODIFY_PURCHASEORDER_CREATE_PAGE: lazy(
		() => import('../pages/presentation/ModifyPurchaseOrder/Create'),
	),
};

const INVENTORY_MANAGEMENT_PAGE = {
	INVENTORY_MANAGEMENT_PAGE: lazy(() => import('../pages/presentation/InventoryManagement')),

	LIVE_PRODUCT_STOCK_PAGE: lazy(
		() => import('../pages/presentation/InventoryManagement/LiveProductStock'),
	),

	STOCK_ADJUSTMENT_PAGE: lazy(
		() => import('../pages/presentation/InventoryManagement/StockAdjustment'),
	),
	STOCK_ADJUSTMENT_DETAIL_PAGE: lazy(
		() => import('../pages/presentation/InventoryManagement/StockAdjustment/Detail'),
	),
	STOCK_ADJUSTMENT_CREATE_PAGE: lazy(
		() => import('../pages/presentation/InventoryManagement/StockAdjustment/Create'),
	),
	// Stock Transfer
	STOCK_TRANSFER_LIST_PAGE: lazy(
		() => import('../pages/presentation/InventoryManagement/StockTransfer'),
	),
	STOCK_TRANSFER_CREATE_PAGE: lazy(
		() => import('../pages/presentation/InventoryManagement/StockTransfer/Create'),
	),
	STOCK_TRANSFER_DETAIL_PAGE: lazy(
		() => import('../pages/presentation/InventoryManagement/StockTransfer/Detail'),
	),
	//master stock
	MASTER_STOCK_PAGE: lazy(
		() => import('../pages/presentation/InventoryManagement/MasterStock/MasterStock'),
	),
	MASTER_STOCK_DETAIL_PAGE: lazy(
		() => import('../pages/presentation/InventoryManagement/MasterStock/Details'),
	),
	MASTER_STOCK_CREATE_PAGE: lazy(
		() => import('../pages/presentation/InventoryManagement/MasterStock/Create'),
	),
	MASTER_STOCK_UPDATE_PAGE: lazy(
		() => import('../pages/presentation/InventoryManagement/MasterStock/Create'),
	),
};

const RESOURCE_INVENTORY_PAGE = {
	// Ware House
	WAREHOUSE_LIST_PAGE: lazy(() => import('../pages/presentation/ResourceInventory/WareHouse')),
	WAREHOUSE_DETAIL_PAGE: lazy(
		() => import('../pages/presentation/ResourceInventory/WareHouse/Details'),
	),
	WAREHOUSE_CREATE_PAGE: lazy(
		() => import('../pages/presentation/ResourceInventory/WareHouse/Create'),
	),
	// Resources
	RESOURCE_LIST_PAGE: lazy(() => import('../pages/presentation/ResourceInventory/Resources')),
	RESOURCE_DETAIL_PAGE: lazy(
		() => import('../pages/presentation/ResourceInventory/Resources/Details'),
	),
	RESOURCE_CREATE_PAGE: lazy(
		() => import('../pages/presentation/ResourceInventory/Resources/Create'),
	),
	// LIve Resources
	RESOURCE_LIVE_PAGE: lazy(() => import('../pages/presentation/ResourceInventory/LiveResource')),
	// Resources Allocation
	RESOURCE_ALLOCATION_LIST_PAGE: lazy(
		() => import('../pages/presentation/ResourceInventory/ResourceAllocation'),
	),
	RESOURCE_ALLOCATION_CREATE_PAGE: lazy(
		() => import('../pages/presentation/ResourceInventory/ResourceAllocation/Create'),
	),
	RESOURCE_ALLOCATION_VERIFY_PAGE: lazy(
		() => import('../pages/presentation/ResourceInventory/ResourceAllocation/VerifyResource'),
	),
};

const CELEBRATION_MANAGEMENT_PAGE = {
	CELEBRATION_MANAGEMENT_PAGE: lazy(
		() => import('../pages/presentation/HRM/CelebrationManagement'),
	),
	CELEBRATION_DETAIL_PAGE: lazy(
		() => import('../pages/presentation/HRM/CelebrationManagement/Detail'),
	),
	CELEBRATION_CREATE_PAGE: lazy(
		() => import('../pages/presentation/HRM/CelebrationManagement/Create'),
	),
};
const ALLOWANCE_MANAGEMENT_PAGE = {
	ALLOWANCE_MANAGEMENT_PAGE: lazy(() => import('../pages/presentation/HRM/AllowanceManagement')),
	ALLOWANCE_DETAIL_PAGE: lazy(
		() => import('../pages/presentation/HRM/AllowanceManagement/Detail'),
	),
	ALLOWANCE_CREATE_PAGE: lazy(
		() => import('../pages/presentation/HRM/AllowanceManagement/Create'),
	),
};
const ATTENDANCE_PAGE = {
	ATTENDANCE_LIST_PAGE: lazy(() => import('../pages/presentation/HRM/Attendance')),
	ATTENDANCE_DETAIL_PAGE: lazy(() => import('../pages/presentation/HRM/Attendance/Detail')),
	ATTENDANCE_CALENDAR_PAGE: lazy(() => import('../pages/presentation/HRM/Attendance/Calender')),
};
const STAFF_PUNCH_DATA_PAGE = {
	STAFF_PUNCH_DATA_LIST_PAGE: lazy(() => import('../pages/presentation/HRM/StaffPunchData')),
};
const MANAGE_ATTENDANCE_PAGE = {
	MANAGE_ATTENDANCE_PAGE: lazy(() => import('../pages/presentation/HRM/ManageAttendance/index')),
};
const STAFF_PAYSLIP_AND_ATTENDANCE = {
	STAFF_PAYSLIP_AND_ATTENDANCE: lazy(
		() => import('../pages/presentation/HRM/Attendance/StaffPaySlipAndAttendance'),
	),
	DETAIL_STAFF_PAYSLIP_AND_ATTENDANCE: lazy(
		() => import('../pages/presentation/HRM/Attendance/StaffPaySlipAndAttendance/Details'),
	),
};

const NOC_MANAGEMENT_PAGE = {
	NOC_LIST_PAGE: lazy(() => import('../pages/presentation/NocManagement')),
	NOC_CREATE_PAGE: lazy(() => import('../pages/presentation/NocManagement/Create')),
	NOC_DETAIL_PAGE: lazy(() => import('../pages/presentation/NocManagement/Details')),
	NOC_EXPIRING_PAGE: lazy(() => import('../pages/presentation/NocManagement/ExpiringNoc')),
	NOC_EXPIRED_PAGE: lazy(() => import('../pages/presentation/NocManagement/ExpiredNoc')),
};
const VEHICLE_MANAGEMENT_PAGE = {
	VEHICLE_LIST_PAGE: lazy(() => import('../pages/presentation/VehicleManagement')),
	VEHICLE_CREATE_PAGE: lazy(() => import('../pages/presentation/VehicleManagement/Create')),
	VEHICLE_DETAIL_PAGE: lazy(() => import('../pages/presentation/VehicleManagement/Details')),
	VEHICLE_EXPIRING_PAGE: lazy(() => import('../pages/presentation/VehicleManagement/ExpiringVehicle')),
	VEHICLE_EXPIRED_PAGE: lazy(() => import('../pages/presentation/VehicleManagement/ExpiredVehicle')),
};
const INQUIRY_MANAGEMENT_PAGE = {
	INQUIRY_LIST_PAGE: lazy(() => import('../pages/presentation/CRM(Inquiry)')),
	INQUIRY_CREATE_PAGE: lazy(() => import('../pages/presentation/CRM(Inquiry)/Create')),
	INQUIRY_DETAIL_PAGE: lazy(() => import('../pages/presentation/CRM(Inquiry)/Details')),
};
const ATTENDANCE_REQUEST_PAGE = {
	ATTENDANCE_REQUEST_PAGE: lazy(() => import('../pages/presentation/AttendanceRequest')),
};
const ATTENDANCE_MONTHLY_PAGE = {
	ATTENDANCE_MONTHLY_PAGE: lazy(() => import('../pages/presentation/AttendanceMonthly')),
};
const ATTENDANCE_MONTHLY_REPORT_PAGE = {
	ATTENDANCE_MONTHLY_REPORT_PAGE: lazy(
		() => import('../pages/presentation//HRM/Attendance/AttendanceMonthlyReport'),
	),
	ATTENDANCE_MONTHLY_REPORT_PAGE_DETAIL: lazy(
		() => import('../pages/presentation//HRM/Attendance/AttendanceMonthlyReport/Detail'),
	),
};
const REQUEST_MANAGEMENT_PAGE = {
	REQUEST_LIST_PAGE: lazy(() => import('../pages/presentation/HRM/RequestManagement')),
	REQUEST_CREATE_PAGE: lazy(() => import('../pages/presentation/HRM/RequestManagement/Create')),
	REQUEST_DETAIL_PAGE: lazy(() => import('../pages/presentation/HRM/RequestManagement/Details')),
};
const AI_REPORTS_PAGE = {
	AI_PRODUCT_REPORT_PAGE: lazy(() => import('../pages/presentation/AIReports/productAIReport')),
	AI_SITE_WISE_SUPPLIER_PAYMENT_INFO_REPORT_PAGE: lazy(() => import('../pages/presentation/AIReports/siteWiseSupplierPaymentInfo')),
	AI_PRODUCT_PURCHASE_ANALYTICS_REPORT_PAGE: lazy(() => import('../pages/presentation/AIReports/ProductPurchaseAnalytics')),
};
const DAYBOOK_PAGE = {
	DAYBOOK_LIST_PAGE: lazy(() => import('../pages/presentation/DayBook')),
	DAYBOOK_DETAIL_PAGE: lazy(() => import('../pages/presentation/DayBook/Details')),
	DAYBOOK_CREATE_PAGE: lazy(() => import('../pages/presentation/DayBook/Create')),
};
const EXPENSES_PAGE = {
	EXPENSES_LIST_PAGE: lazy(() => import('../pages/presentation/Expenses')),
	EXPENSES_DETAIL_PAGE: lazy(() => import('../pages/presentation/Expenses/Details')),
	EXPENSES_CREATE_PAGE: lazy(() => import('../pages/presentation/Expenses/Create')),
};
const NOTIFICATIONS_PAGE = {
	NOTIFICATIONS_LIST_PAGE: lazy(() => import('../pages/presentation/Notifications')),
	NOTIFICATIONS_DETAIL_PAGE: lazy(() => import('../pages/presentation/Notifications/Details')),
	NOTIFICATIONS_CREATE_PAGE: lazy(() => import('../pages/presentation/DayBook/Create')),
};

const QUICK_PAYMENT_PAGE = {
	QUICK_PAYMENT_LIST_PAGE: lazy(() => import('../pages/presentation/QuickPayment')),
	QUICK_PAYMENT_DETAIL_PAGE: lazy(() => import('../pages/presentation/QuickPayment/Details')),
	QUICK_PAYMENT_CREATE_PAGE: lazy(() => import('../pages/presentation/QuickPayment/Create')),
};

const DELETE_DATA_PAGE = {
	DELETE_DATA_LIST_PAGE: lazy(() => import('../pages/presentation/DeleteData/DeleteData')),
};

// const EXTRA = {
// 	NOTIFICATION: lazy(() => import('../pages/documentation/extras/NotificationPage')),
// 	HOOKS: lazy(() => import('../pages/documentation/extras/HooksPage')),
// };

const presentation: RouteProps[] = [
	/**
	 * Landing
	 */
	{
		path: dashboardPagesMenu.dashboard.path,
		element: <LANDING.DASHBOARD />,
	},
	//Delete Data
	{
		path: demoPagesMenu.deleteDataPage.path,
		element: <DeleteDataPage />,
	},
	//Role
	{
		path: dashboardPagesMenu.roleAndPermissionPage.subMenu.role.path,
		element: <ROLE_PAGE.ROLE_PAGE />,
	},
	//Permission
	{
		path: dashboardPagesMenu.roleAndPermissionPage.subMenu.permission.path,
		element: <PERMISSION_PAGE.PERMISSION_PAGE />,
	},
	//Permission Allocation
	{
		path: dashboardPagesMenu.roleAndPermissionPage.subMenu.permissionAllocation.path,
		element: <PERMISSION_ALLOCATION_PAGE.PERMISSION_ALLOCATION_PAGE />,
	},
	//account
	{
		path: dashboardPagesMenu.accountPage.path,
		element: <ACCOUNT_PAGE.ACCOUNT_PAGE />,
	},
	{
		path: dashboardPagesMenu.accountPage.subMenu.createAccount.path,
		element: <ACCOUNT_ADD_PAGE.ACCOUNT_ADD_PAGE />,
	},
	{
		path: dashboardPagesMenu.accountPage.subMenu.detailAccount.path,
		element: <ACCOUNT_DETAIL_PAGE.ACCOUNT_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.accountPage.subMenu.editAccount.path,
		element: <ACCOUNT_ADD_PAGE.ACCOUNT_ADD_PAGE />,
	},
	//Product
	{
		path: dashboardPagesMenu.productPages.path,
		element: <PRODUCT_PAGE.PRODUCT_PAGE />,
	},
	{
		path: dashboardPagesMenu.productPages.subMenu.createProduct.path,
		element: <PRODUCT_ADD_PAGE.PRODUCT_ADD_PAGE />,
	},
	{
		path: dashboardPagesMenu.productPages.subMenu.editProduct.path,
		element: <PRODUCT_ADD_PAGE.PRODUCT_ADD_PAGE />,
	},
	{
		path: dashboardPagesMenu.productPages.subMenu.detailProduct.path,
		element: <PRODUCT_DETAIL_PAGE.PRODUCT_DETAIL_PAGE />,
	},
	// product category
	{
		path: dashboardPagesMenu.productPages.subMenu.productCategoryPages.path,
		element: <PRODUCT_CATEGORY_PAGE.PRODUCT_CATEGORY_PAGE />,
	},
	{
		path: dashboardPagesMenu.productPages.subMenu.productCategoryPages.subMenu.createCategory
			.path,
		element: <PRODUCT_CATEGORY_ADD_PAGE.PRODUCT_CATEGORY_ADD_PAGE />,
	},
	{
		path: dashboardPagesMenu.productPages.subMenu.productCategoryPages.subMenu.editCategory
			.path,
		element: <PRODUCT_CATEGORY_ADD_PAGE.PRODUCT_CATEGORY_ADD_PAGE />,
	},
	// product unit
	{
		path: dashboardPagesMenu.productPages.subMenu.productUnitPages.path,
		element: <PRODUCT_UNIT_PAGE.PRODUCT_UNIT_PAGE />,
	},
	{
		path: dashboardPagesMenu.productPages.subMenu.productUnitPages.subMenu.createUnit.path,
		element: <PRODUCT_UNIT_ADD_PAGE.PRODUCT_UNIT_ADD_PAGE />,
	},
	// {
	// 	path: dashboardPagesMenu.productUnitPages.subMenu.detailUnit.path,
	// 	element: <PRODUCT_UNIT_DETAIL_PAGE.PRODUCT_UNIT_DETAIL_PAGE />,
	// },
	{
		path: dashboardPagesMenu.productPages.subMenu.productUnitPages.subMenu.editUnit.path,
		element: <PRODUCT_UNIT_ADD_PAGE.PRODUCT_UNIT_ADD_PAGE />,
	},
	// purchase
	{
		path: dashboardPagesMenu.purchasePages.path,
		element: <PURCHASE_PAGE.PURCHASE_PAGE />,
	},
	{
		path: dashboardPagesMenu.purchasePages.subMenu.createPurchase.path,
		element: <PURCHASE_ADD_PAGE.PURCHASE_ADD_PAGE />,
	},
	{
		path: dashboardPagesMenu.purchasePages.subMenu.editPurchase.path,
		element: <PURCHASE_ADD_PAGE.PURCHASE_ADD_PAGE />,
	},
	{
		path: dashboardPagesMenu.purchasePages.subMenu.detailsPurchase.path,
		element: <PURCHASE_DETAIL_PAGE.PURCHASE_DETAIL_PAGE />,
	},
	// analytics
	{
		path: dashboardPagesMenu.analyticsPage.path,
		element: <ANALYTIC_PAGE.ANALYTIC_PAGE />,
	},
	// area
	{
		path: dashboardPagesMenu.areaPage.path,
		element: <AREA_PAGE.AREA_LIST_PAGE />,
	},

	{
		path: dashboardPagesMenu.areaPage.subMenu.createArea.path,
		element: <AREA_PAGE.AREA_CREATE_PAGE />,
	},

	{
		path: `${dashboardPagesMenu.areaPage.subMenu.updateArea.path}`,
		element: <AREA_PAGE.AREA_CREATE_PAGE />,
	},

	// site verification checklist
	{
		path: dashboardPagesMenu.siteVerificationChecklistPage.subMenu.siteVerificationChecklistPage
			.path,
		element: <SITE_VERIFICATION_CHECKLIST_PAGE.SITE_VERIFICATION_CHECKLIST_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.siteVerificationChecklistPage.subMenu.siteVerificationChecklistPage
			.subMenu.createSiteVerificationChecklist.path,
		element: <SITE_VERIFICATION_CHECKLIST_PAGE.SITE_VERIFICATION_CHECKLIST_CREATE_PAGE />,
	},
	{
		path: `${dashboardPagesMenu.siteVerificationChecklistPage.subMenu.siteVerificationChecklistPage.subMenu.updateSiteVerificationChecklist.path}`,
		element: <SITE_VERIFICATION_CHECKLIST_PAGE.SITE_VERIFICATION_CHECKLIST_UPDATE_PAGE />,
	},
	// site verification
	{
		path: dashboardPagesMenu.siteVerificationChecklistPage.subMenu.siteVerificationPage.path,
		element: <SITE_VERIFICATION_PAGE.SITE_VERIFICATION_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.siteVerificationChecklistPage.subMenu.siteVerificationPage.subMenu
			.createSiteVerification.path,
		element: <SITE_VERIFICATION_PAGE.SITE_VERIFICATION_CREATE_PAGE />,
	},
	{
		path: `${dashboardPagesMenu.siteVerificationChecklistPage.subMenu.siteVerificationPage.subMenu.updateSiteVerification.path}`,
		element: <SITE_VERIFICATION_PAGE.SITE_VERIFICATION_UPDATE_PAGE />,
	},
	{
		path: `${dashboardPagesMenu.siteVerificationChecklistPage.subMenu.siteVerificationPage.subMenu.detailSiteVerification.path}`,
		element: <SITE_VERIFICATION_PAGE.SITE_VERIFICATION_DETAIL_PAGE />,
	},
	// site Management Showcase
	{
		path: dashboardPagesMenu.siteManagementPage.path,
		element: <SITE_MANAGEMENT_PAGE.SITE_MANAGEMENT_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.siteManagementPage.subMenu.createSiteManagement.path,
		element: <SITE_MANAGEMENT_PAGE.SITE_MANAGEMENT_CREATE_PAGE />,
	},
	{
		path: `${dashboardPagesMenu.siteManagementPage.subMenu.updateSiteManagement.path}`,
		element: <SITE_MANAGEMENT_PAGE.SITE_MANAGEMENT_UPDATE_PAGE />,
	},
	{
		path: `${dashboardPagesMenu.siteManagementPage.subMenu.detailSiteManagement.path}`,
		element: <SITE_MANAGEMENT_PAGE.SITE_MANAGEMENT_DETAIL_PAGE />,
	},
	{
		path: `${dashboardPagesMenu.siteManagementPage.subMenu.siteManagementSummary.path}`,
		element: <SITE_MANAGEMENT_PAGE.SITE_MANAGEMENT_SUMMARY_PAGE />,
	},
	// Salary Structure
	{
		path: dashboardPagesMenu.hrmPage.subMenu.salaryStructureManagement.path,
		element: <SITE_MANAGEMENT_STRUCTURE_PAGE.SITE_MANAGEMENT_STRUCTURE_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.salaryStructureManagement.subMenu
			.createStaffSalaryStructure.path,
		element: <SITE_MANAGEMENT_STRUCTURE_PAGE.SITE_MANAGEMENT_STRUCTURE_CREATE_PAGE />,
	},
	{
		path: `${dashboardPagesMenu.hrmPage.subMenu.salaryStructureManagement.subMenu.updateStaffSalaryStructure.path}`,
		element: <SITE_MANAGEMENT_STRUCTURE_PAGE.SITE_MANAGEMENT_STRUCTURE_UPDATE_PAGE />,
	},
	{
		path: `${dashboardPagesMenu.hrmPage.subMenu.salaryStructureManagement.subMenu.detailStaffSalaryStructure.path}`,
		element: <SITE_MANAGEMENT_STRUCTURE_PAGE.SITE_MANAGEMENT_STRUCTURE_DETAIL_PAGE />,
	},
	// Salary Increments
	{
		path: `${dashboardPagesMenu.hrmPage.subMenu.salaryIncrement.path}`,
		element: <SALARY_INCREMENT_PAGE.SALARY_INCREMENT_LIST_PAGE />,
	},
	// notification
	{
		path: dashboardPagesMenu.notificationConfigPage.path,
		element: <NOTIFICATION_PAGE.NOTIFICATION_LIST_PAGE />,
	},

	{
		path: dashboardPagesMenu.notificationConfigPage.subMenu.createNotificationConfig.path,
		element: <NOTIFICATION_PAGE.NOTIFICATION_CREATE_PAGE />,
	},

	{
		path: `${dashboardPagesMenu.notificationConfigPage.subMenu.updateNotificationConfig.path}`,
		element: <NOTIFICATION_PAGE.NOTIFICATION_CREATE_PAGE />,
	},
	// Contract Management
	{
		path: dashboardPagesMenu.contractManagementPage.path,
		element: <CONTRACT_MANAGEMENT_PAGE.CONTRACT_MANAGEMENT_LIST_PAGE />,
	},

	{
		path: dashboardPagesMenu.contractManagementPage.subMenu.createContractManagement.path,
		element: <CONTRACT_MANAGEMENT_PAGE.CONTRACT_MANAGEMENT_CREATE_PAGE />,
	},

	{
		path: `${dashboardPagesMenu.contractManagementPage.subMenu.updateContractManagement.path}`,
		element: <CONTRACT_MANAGEMENT_PAGE.CONTRACT_MANAGEMENT_CREATE_PAGE />,
	},
	{
		path: `${dashboardPagesMenu.contractManagementPage.subMenu.detailContractManagement.path}`,
		element: <CONTRACT_MANAGEMENT_PAGE.CONTRACT_MANAGEMENT_DETAIL_PAGE />,
	},
	{
		path: `${dashboardPagesMenu.contractManagementPage.subMenu.expiringAMCManagement.path}`,
		element: <CONTRACT_MANAGEMENT_PAGE.CONTRACT_EXPIRING_PAGE />,
	},
	{
		path: `${dashboardPagesMenu.contractManagementPage.subMenu.expiredAMCManagement.path}`,
		element: <CONTRACT_MANAGEMENT_PAGE.CONTRACT_EXPIRED_PAGE />,
	},
	// device
	{
		path: dashboardPagesMenu.hrmPage.subMenu.devicePage.path,
		element: <DEVICE_PAGE.DEVICE_LIST_PAGE />,
	},

	{
		path: dashboardPagesMenu.hrmPage.subMenu.devicePage.subMenu.createDevice.path,
		element: <DEVICE_PAGE.DEVICE_CREATE_PAGE />,
	},

	{
		path: `${dashboardPagesMenu.hrmPage.subMenu.devicePage.subMenu.updateDevice.path}`,
		element: <DEVICE_PAGE.DEVICE_CREATE_PAGE />,
	},
	{
		path: `${dashboardPagesMenu.hrmPage.subMenu.devicePage.subMenu.detailDevice.path}`,
		element: <DEVICE_PAGE.DEVICE_DEATIL_PAGE />,
	},
	// device user
	{
		path: dashboardPagesMenu.hrmPage.subMenu.deviceUserPage.path,
		element: <DEVICE_USER_PAGE.DEVICE_USER_LIST_PAGE />,
	},

	{
		path: dashboardPagesMenu.hrmPage.subMenu.deviceUserPage.subMenu.createDeviceUser.path,
		element: <DEVICE_USER_PAGE.DEVICE_USER_CREATE_PAGE />,
	},

	{
		path: `${dashboardPagesMenu.hrmPage.subMenu.deviceUserPage.subMenu.updateDeviceUser.path}`,
		element: <DEVICE_USER_PAGE.DEVICE_USER_CREATE_PAGE />,
	},
	// staff salary
	{
		path: dashboardPagesMenu.hrmPage.subMenu.salaryManagement.path,
		element: <STAFF_SALARY_PAGE.STAFF_SALARY_LIST_PAGE />,
	},

	{
		path: dashboardPagesMenu.hrmPage.subMenu.salaryManagement.subMenu.createStaffSalary.path,
		element: <STAFF_SALARY_PAGE.STAFF_SALARY_CREATE_PAGE />,
	},
	{
		path: `${dashboardPagesMenu.hrmPage.subMenu.salaryManagement.subMenu.updateStaffSalary.path}`,
		element: <STAFF_SALARY_PAGE.STAFF_SALARY_CREATE_PAGE />,
	},
	{
		path: `${dashboardPagesMenu.hrmPage.subMenu.salaryManagement.subMenu.detailStaffSalary.path}`,
		element: <STAFF_SALARY_PAGE.STAFF_SALARY_DETAILS_PAGE />,
	},
	// Company
	{
		path: dashboardPagesMenu.companyPage.path,
		element: <COMPANY_PAGE.COMPANY_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.companyPage.subMenu.createCompany.path,
		element: <COMPANY_PAGE.COMPANY_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.companyPage.subMenu.editCompany.path,
		element: <COMPANY_PAGE.COMPANY_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.companyPage.subMenu.detailCompany.path,
		element: <COMPANY_PAGE.COMPANY_DETAIL_PAGE />,
	},
	// Verification Process
	{
		path: dashboardPagesMenu.verificationProcessPage.path,
		element: <VERIFICATION_PAGE.VERIFICATION_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.verificationProcessPage.subMenu.requisition.path,
		element: <VERIFICATION_PAGE.REQUISITION_PAGE />,
	},
	{
		path: dashboardPagesMenu.verificationProcessPage.subMenu.purchase_indent.path,
		element: <VERIFICATION_PAGE.PURCHASE_INDENT_PAGE />,
	},
	{
		path: dashboardPagesMenu.verificationProcessPage.subMenu.purchase_order.path,
		element: <VERIFICATION_PAGE.PURCHASE_ORDER_PAGE />,
	},
	{
		path: dashboardPagesMenu.verificationProcessPage.subMenu.purchase_bill.path,
		element: <VERIFICATION_PAGE.PURCHASE_BILL_PAGE />,
	},
	{
		path: dashboardPagesMenu.verificationProcessPage.subMenu.cheque_signature.path,
		element: <VERIFICATION_PAGE.CHEQUE_SIGNATURE />,
	},
	//PurchaseIndent
	{
		path: dashboardPagesMenu.purchaseIndentPage.path,
		element: <PURCHASE_INDENT_PAGE.PURCHASE_INDENT_PAGE />,
	},
	{
		path: dashboardPagesMenu.purchaseIndentPage.subMenu.createPurchaseIndent.path,
		element: <PURCHASE_INDENT_ADD_PAGE.PURCHASE_INDENT_ADD_PAGE />,
	},
	{
		path: dashboardPagesMenu.purchaseIndentPage.subMenu.detailPurchaseIndent.path,
		element: <PURCHASE_INDENT_DETAIL_PAGE.PURCHASE_INDENT_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.purchaseIndentPage.subMenu.editPurchaseIndent.path,
		element: <PURCHASE_INDENT_ADD_PAGE.PURCHASE_INDENT_ADD_PAGE />,
	},
	//ConfirmedIndent
	{
		path: dashboardPagesMenu.confirmIndentPage.path,
		element: <PURCHASE_CONFIRM_INDENT_PAGE.PURCHASE_CONFIRM_INDENT_PAGE />,
	},
	// Staff
	{
		path: dashboardPagesMenu.staffPage.path,
		element: <STAFF_PAGE.STAFF_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.staffPage.subMenu.createStaff.path,
		element: <STAFF_PAGE.STAFF_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.staffPage.subMenu.editStaff.path,
		element: <STAFF_PAGE.STAFF_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.staffPage.subMenu.detailStaff.path,
		element: <STAFF_PAGE.STAFF_DETAIL_PAGE />,
	},
	//PurchaseOrder
	{
		path: dashboardPagesMenu.purchaseOrderPage.path,
		element: <PURCHASEORDER_PAGE.PURCHASEORDER_PAGE />,
	},
	{
		path: dashboardPagesMenu.purchaseOrderPage.subMenu.createPurchaseOrder.path,
		element: <PURCHASEORDER_ADD_PAGE.PURCHASEORDER_ADD_PAGE />,
	},
	{
		path: dashboardPagesMenu.purchaseOrderPage.subMenu.detailPurchaseOrder.path,
		element: <PURCHASEORDER_DETAIL_PAGE.PURCHASEORDER_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.purchaseOrderPage.subMenu.editPurchaseOrder.path,
		element: <PURCHASEORDER_ADD_PAGE.PURCHASEORDER_ADD_PAGE />,
	},
	{
		path: dashboardPagesMenu.purchaseOrderRequestPage.path,
		element: <PURCHASEORDERREQUEST_PAGE.PURCHASEORDERREQUEST_PAGE />,
	},
	//ModifyPurchaseOrder
	{
		path: dashboardPagesMenu.modifyPurchaseOrderPage.path,
		element: <MODIFY_PURCHASEORDER_PAGE.MODIFY_PURCHASEORDER_PAGE />,
	},
	{
		path: dashboardPagesMenu.modifyPurchaseOrderRequestPage.path,
		element: <MODIFY_PURCHASEORDER_PAGE.MODIFY_PO_REQUEST_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.modifyPurchaseOrderPage.subMenu
			.detailModifyPurchaseOrder.path,
		element: <MODIFY_PURCHASEORDER_PAGE.MODIFY_PURCHASEORDER_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.modifyPurchaseOrderPage.subMenu
			.createModifyPurchaseOrder.path,
		element: <MODIFY_PURCHASEORDER_PAGE.MODIFY_PURCHASEORDER_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.modifyPurchaseOrderPage.subMenu
			.editModifyPurchaseOrder.path,
		element: <MODIFY_PURCHASEORDER_PAGE.MODIFY_PURCHASEORDER_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.modifyPurchaseOrderPage.subMenu
			.createManualModifyPurchaseOrder.path,
		element: <MODIFY_PURCHASEORDER_PAGE.MODIFY_PURCHASEORDER_CREATE_PAGE />,
	},

	// Role
	{
		path: settingPageMenu.settingsPage.subMenu.listRole.path,
		element: <SETTINGS_PAGE.ROLE_PAGE />,
	},
	// profile
	{
		path: dashboardPagesMenu.updateProfilePage.path,
		element: <UPDATE_PROFILE_PAGE.UPDATE_PROFILE_PAGE />,
	},
	// Place Of Supply
	{
		path: dashboardPagesMenu.placeOfSupplyPage.path,
		element: <PLACE_OF_SUPPLY_PAGE.PLACE_OF_SUPPLY_PAGE />,
	},
	{
		path: dashboardPagesMenu.placeOfSupplyPage.subMenu.createPlaceOfSupply.path,
		element: <PLACE_OF_SUPPLY_PAGE.PLACE_OF_SUPPLY_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.placeOfSupplyPage.subMenu.editPlaceOfSupply.path,
		element: <PLACE_OF_SUPPLY_PAGE.PLACE_OF_SUPPLY_CREATE_PAGE />,
	},
	// Payment Type
	{
		path: dashboardPagesMenu.paymentPage.subMenu.paymentTypePage.path,
		element: <PAYMENT_TYPE_PAGE.PAYMENT_TYPE_PAGE />,
	},
	// Payment Type Create
	{
		path: dashboardPagesMenu.paymentPage.subMenu.paymentTypePage.subMenu.createPaymentType.path,
		element: <PAYMENT_TYPE_CREATE_PAGE.PAYMENT_TYPE_CREATE_PAGE />,
	},
	// Payment
	{
		path: dashboardPagesMenu.paymentPage.path,
		element: <PAYMENT_PAGE.PAYMENT_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.paymentPage.subMenu.createPayment.path,
		element: <PAYMENT_PAGE.PAYMENT_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.paymentPage.subMenu.editPayment.path,
		element: <PAYMENT_PAGE.PAYMENT_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.paymentPage.subMenu.detailPayment.path,
		element: <PAYMENT_PAGE.PAYMENT_DETAIL_PAGE />,
	},
	// Payment Terms
	{
		path: dashboardPagesMenu.paymentPage.subMenu.paymentTermsPage.path,
		element: <PAYMENT_TERMS_PAGE.PAYMENT_TERMS_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.paymentPage.subMenu.paymentTermsPage.subMenu.createPaymentTerms
			.path,
		element: <PAYMENT_TERMS_PAGE.PAYMENT_TERMS_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.paymentPage.subMenu.paymentTermsPage.subMenu.editPaymentTerms.path,
		element: <PAYMENT_TERMS_PAGE.PAYMENT_TERMS_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.paymentPage.subMenu.paymentTermsPage.subMenu.detailPaymentTerms
			.path,
		element: <PAYMENT_TERMS_PAGE.PAYMENT_TERMS_DETAIL_PAGE />,
	},
	// Payment Verification
	{
		path: dashboardPagesMenu.paymentPage.subMenu.paymentVerificationPage.path,
		element: <PAYMENT_VERIFICATION_PAGE.PAYMENT_VERIFICATION_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.paymentPage.subMenu.paymentVerificationPage.subMenu
			.createPaymentVerification.path,
		element: <PAYMENT_VERIFICATION_PAGE.PAYMENT_VERIFICATION_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.paymentPage.subMenu.paymentVerificationPage.subMenu
			.editPaymentVerification.path,
		element: <PAYMENT_VERIFICATION_PAGE.PAYMENT_VERIFICATION_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.paymentPage.subMenu.paymentVerificationPage.subMenu
			.detailPaymentVerification.path,
		element: <PAYMENT_VERIFICATION_PAGE.PAYMENT_VERIFICATION_DETAIL_PAGE />,
	},
	// Payment Steps
	{
		path: dashboardPagesMenu.paymentPage.subMenu.paymentStepPage.path,
		element: <PAYMENT_STEPS_PAGE.PAYMENT_STEPS_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.paymentPage.subMenu.paymentStepPage.subMenu.createPaymentStep.path,
		element: <PAYMENT_STEPS_PAGE.PAYMENT_STEPS_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.paymentPage.subMenu.paymentStepPage.subMenu.editPaymentStep.path,
		element: <PAYMENT_STEPS_PAGE.PAYMENT_STEPS_CREATE_PAGE />,
	},
	// Quick Payment
	{
		path: dashboardPagesMenu.paymentPage.subMenu.quickPaymentPage.path,
		element: <QUICK_PAYMENT_PAGE.QUICK_PAYMENT_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.paymentPage.subMenu.quickPaymentPage.subMenu.createQuickPayment.path,
		element: <QUICK_PAYMENT_PAGE.QUICK_PAYMENT_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.paymentPage.subMenu.quickPaymentPage.subMenu.editQuickPayment.path,
		element: <QUICK_PAYMENT_PAGE.QUICK_PAYMENT_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.paymentPage.subMenu.quickPaymentPage.subMenu.detailQuickPayment.path,
		element: <QUICK_PAYMENT_PAGE.QUICK_PAYMENT_DETAIL_PAGE />,
	},
	// {
	// 	path: dashboardPagesMenu.paymentTermsPage.subMenu.detailPaymentTerms.path,
	// 	element: <PAYMENT_TERMS_PAGE.PAYMENT_TERMS_DETAIL_PAGE />,
	// },
	// Requisition
	{
		path: dashboardPagesMenu.requisitionPage.path,
		element: <REQUISTION_PAGE.REQUISTION_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.requisitionPage.subMenu.detailsRequisition.path,
		element: <REQUISTION_PAGE.REQUISTION_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.requisitionPage.subMenu.createRequisition.path,
		element: <REQUISTION_PAGE.REQUISTION_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.requisitionPage.subMenu.editRequisition.path,
		element: <REQUISTION_PAGE.REQUISTION_CREATE_PAGE />,
	},
	// GRN
	{
		path: dashboardPagesMenu.grnPages.path,
		element: <GRN_PAGE.GRN_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.grnPages.subMenu.detailsGrn.path,
		element: <GRN_PAGE.GRN_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.grnPages.subMenu.createGrn.path,
		element: <GRN_PAGE.GRN_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.grnPages.subMenu.editGrn.path,
		element: <GRN_PAGE.GRN_CREATE_PAGE />,
	},
	// Payment Type Edit
	{
		path: dashboardPagesMenu.paymentPage.subMenu.paymentTypePage.subMenu.editPaymentType.path,
		element: <PAYMENT_TYPE_CREATE_PAGE.PAYMENT_TYPE_CREATE_PAGE />,
	},
	// Quotation
	{
		path: dashboardPagesMenu.quotationPage.path,
		element: <QUOTATION_PAGE.QUOTATION_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.quotationPage.subMenu.createQuotation.path,
		element: <QUOTATION_PAGE.QUOTATION_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.quotationPage.subMenu.editQuotation.path,
		element: <QUOTATION_PAGE.QUOTATION_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.quotationPage.subMenu.detailQuotation.path,
		element: <QUOTATION_PAGE.QUOTATION_DETAIL_PAGE />,
	},
	// HRM > Holiday Management
	{
		path: dashboardPagesMenu.hrmPage.subMenu.holidayManagement.path,
		element: <HOLIDAY_PAGE.HOLIDAY_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.holidayManagement.subMenu.createHoliday.path,
		element: <HOLIDAY_PAGE.HOLIDAY_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.holidayManagement.subMenu.editHoliday.path,
		element: <HOLIDAY_PAGE.HOLIDAY_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.holidayManagement.subMenu.detailHoliday.path,
		element: <HOLIDAY_PAGE.HOLIDAY_DETAIL_PAGE />,
	},
	// HRM > Shift Management
	{
		path: dashboardPagesMenu.hrmPage.subMenu.shiftManagement.path,
		element: <SHIFT_MANAGEMENT_PAGE.SHIFT_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.shiftManagement.subMenu.createShift.path,
		element: <SHIFT_MANAGEMENT_PAGE.SHIFT_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.shiftManagement.subMenu.editShift.path,
		element: <SHIFT_MANAGEMENT_PAGE.SHIFT_CREATE_PAGE />,
	},
	// Inventory Management master
	{
		path: dashboardPagesMenu.inventoryManagementPage.subMenu.masterStockPage.path,
		element: <INVENTORY_MANAGEMENT_PAGE.MASTER_STOCK_PAGE />,
	},
	{
		path: dashboardPagesMenu.inventoryManagementPage.subMenu.masterStockPage.subMenu
			.detailStockAdjustmentPage.path,
		element: <INVENTORY_MANAGEMENT_PAGE.MASTER_STOCK_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.inventoryManagementPage.subMenu.masterStockPage.subMenu
			.createMasterStockPage.path,
		element: <INVENTORY_MANAGEMENT_PAGE.MASTER_STOCK_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.inventoryManagementPage.subMenu.masterStockPage.subMenu
			.updateMasterStockPage.path,
		element: <INVENTORY_MANAGEMENT_PAGE.MASTER_STOCK_UPDATE_PAGE />,
	},
	// Inventory Management
	{
		path: dashboardPagesMenu.inventoryManagementPage.path,
		element: <INVENTORY_MANAGEMENT_PAGE.INVENTORY_MANAGEMENT_PAGE />,
	},
	// Inventory Management > Live Product Stock
	{
		path: dashboardPagesMenu.inventoryManagementPage.subMenu.liveProductStockPage.path,
		element: <INVENTORY_MANAGEMENT_PAGE.LIVE_PRODUCT_STOCK_PAGE />,
	},
	// Inventory Management > Stock Adjustment
	{
		path: dashboardPagesMenu.inventoryManagementPage.subMenu.stockAdjustmentPage.path,
		element: <INVENTORY_MANAGEMENT_PAGE.STOCK_ADJUSTMENT_PAGE />,
	},
	{
		path: dashboardPagesMenu.inventoryManagementPage.subMenu.stockAdjustmentPage.subMenu
			.detailStockAdjustmentPage.path,
		element: <INVENTORY_MANAGEMENT_PAGE.STOCK_ADJUSTMENT_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.inventoryManagementPage.subMenu.stockAdjustmentPage.subMenu
			.createStockAdjustmentPage.path,
		element: <INVENTORY_MANAGEMENT_PAGE.STOCK_ADJUSTMENT_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.inventoryManagementPage.subMenu.stockAdjustmentPage.subMenu
			.editStockAdjustmentPage.path,
		element: <INVENTORY_MANAGEMENT_PAGE.STOCK_ADJUSTMENT_CREATE_PAGE />,
	},
	// Inventory Management > Stock Transfer
	{
		path: dashboardPagesMenu.inventoryManagementPage.subMenu.stockTransferPage.path,
		element: <INVENTORY_MANAGEMENT_PAGE.STOCK_TRANSFER_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.inventoryManagementPage.subMenu.stockTransferPage.subMenu
			.createStockTransfer.path,
		element: <INVENTORY_MANAGEMENT_PAGE.STOCK_TRANSFER_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.inventoryManagementPage.subMenu.stockTransferPage.subMenu
			.editStockTransfer.path,
		element: <INVENTORY_MANAGEMENT_PAGE.STOCK_TRANSFER_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.inventoryManagementPage.subMenu.stockTransferPage.subMenu
			.detailStockTransfer.path,
		element: <INVENTORY_MANAGEMENT_PAGE.STOCK_TRANSFER_DETAIL_PAGE />,
	},
	// Resource Inventory > Ware House
	{
		path: dashboardPagesMenu.resourceInventoryPage.subMenu.warehouse.path,
		element: <RESOURCE_INVENTORY_PAGE.WAREHOUSE_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.resourceInventoryPage.subMenu.warehouse.subMenu.detailWarehouse
			.path,
		element: <RESOURCE_INVENTORY_PAGE.WAREHOUSE_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.resourceInventoryPage.subMenu.warehouse.subMenu.createWarehouse
			.path,
		element: <RESOURCE_INVENTORY_PAGE.WAREHOUSE_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.resourceInventoryPage.subMenu.warehouse.subMenu.editWarehouse.path,
		element: <RESOURCE_INVENTORY_PAGE.WAREHOUSE_CREATE_PAGE />,
	},
	// Resource Inventory > Resources
	{
		path: dashboardPagesMenu.resourceInventoryPage.subMenu.resources.path,
		element: <RESOURCE_INVENTORY_PAGE.RESOURCE_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.resourceInventoryPage.subMenu.resources.subMenu.detailResource
			.path,
		element: <RESOURCE_INVENTORY_PAGE.RESOURCE_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.resourceInventoryPage.subMenu.resources.subMenu.createResource
			.path,
		element: <RESOURCE_INVENTORY_PAGE.RESOURCE_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.resourceInventoryPage.subMenu.resources.subMenu.editResource.path,
		element: <RESOURCE_INVENTORY_PAGE.RESOURCE_CREATE_PAGE />,
	},
	// Resource Inventory > Live Resources
	{
		path: dashboardPagesMenu.resourceInventoryPage.subMenu.liveResourcesByCompanyWarehouse.path,
		element: <RESOURCE_INVENTORY_PAGE.RESOURCE_LIVE_PAGE />,
	},
	// Resource Inventory > Resources Allocation
	{
		path: dashboardPagesMenu.resourceInventoryPage.subMenu.resourceAllocation.path,
		element: <RESOURCE_INVENTORY_PAGE.RESOURCE_ALLOCATION_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.resourceInventoryPage.subMenu.resourceAllocation.subMenu
			.createResource.path,
		element: <RESOURCE_INVENTORY_PAGE.RESOURCE_ALLOCATION_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.resourceInventoryPage.subMenu.resourceAllocation.subMenu
			.verifyResource.path,
		element: <RESOURCE_INVENTORY_PAGE.RESOURCE_ALLOCATION_VERIFY_PAGE />,
	},
	// Celebration Management
	{
		path: dashboardPagesMenu.hrmPage.subMenu.celebrationManagement.path,
		element: <CELEBRATION_MANAGEMENT_PAGE.CELEBRATION_MANAGEMENT_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.celebrationManagement.subMenu
			.detailStaffCelebration.path,
		element: <CELEBRATION_MANAGEMENT_PAGE.CELEBRATION_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.celebrationManagement.subMenu
			.createStaffCelebration.path,
		element: <CELEBRATION_MANAGEMENT_PAGE.CELEBRATION_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.celebrationManagement.subMenu
			.updateStaffCelebration.path,
		element: <CELEBRATION_MANAGEMENT_PAGE.CELEBRATION_CREATE_PAGE />,
	},
	// Allowance Management
	{
		path: dashboardPagesMenu.hrmPage.subMenu.allowanceManagement.path,
		element: <ALLOWANCE_MANAGEMENT_PAGE.ALLOWANCE_MANAGEMENT_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.allowanceManagement.subMenu.detailStaffAllowance
			.path,
		element: <ALLOWANCE_MANAGEMENT_PAGE.ALLOWANCE_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.allowanceManagement.subMenu.createStaffAllowance
			.path,
		element: <ALLOWANCE_MANAGEMENT_PAGE.ALLOWANCE_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.allowanceManagement.subMenu.updateStaffAllowance
			.path,
		element: <ALLOWANCE_MANAGEMENT_PAGE.ALLOWANCE_CREATE_PAGE />,
	},
	// HRM Attendance
	{
		path: dashboardPagesMenu.hrmPage.subMenu.attendance.path,
		element: <ATTENDANCE_PAGE.ATTENDANCE_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.attendance.subMenu.detailAttendance.path,
		element: <ATTENDANCE_PAGE.ATTENDANCE_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.attendance.subMenu.calendar.path,
		element: <ATTENDANCE_PAGE.ATTENDANCE_CALENDAR_PAGE />,
	},
	// HRM Attendance > Staff Payslip ANd Attendance
	{
		path: dashboardPagesMenu.hrmPage.subMenu.attendance.subMenu.staffPaySlipAndAttendance.path,
		element: <STAFF_PAYSLIP_AND_ATTENDANCE.STAFF_PAYSLIP_AND_ATTENDANCE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.attendance.subMenu.staffPaySlipAndAttendance
			.subMenu.detailStaffPaySlipAndAttendance.path,
		element: <STAFF_PAYSLIP_AND_ATTENDANCE.DETAIL_STAFF_PAYSLIP_AND_ATTENDANCE />,
	},
	// HRM Staff Punch Data
	{
		path: dashboardPagesMenu.hrmPage.subMenu.staffPunchDataPage.path,
		element: <STAFF_PUNCH_DATA_PAGE.STAFF_PUNCH_DATA_LIST_PAGE />,
	},
	// HRM > Manage Attendance
	{
		path: dashboardPagesMenu.hrmPage.subMenu.manageAttendancePage.path,
		element: <MANAGE_ATTENDANCE_PAGE.MANAGE_ATTENDANCE_PAGE />,
	},
	// NOC Management
	{
		path: dashboardPagesMenu.nocManagementPage.path,
		element: <NOC_MANAGEMENT_PAGE.NOC_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.nocManagementPage.subMenu.createNocManagement.path,
		element: <NOC_MANAGEMENT_PAGE.NOC_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.nocManagementPage.subMenu.updateNocManagement.path,
		element: <NOC_MANAGEMENT_PAGE.NOC_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.nocManagementPage.subMenu.detailNocManagement.path,
		element: <NOC_MANAGEMENT_PAGE.NOC_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.nocManagementPage.subMenu.expiringNocManagement.path,
		element: <NOC_MANAGEMENT_PAGE.NOC_EXPIRING_PAGE />,
	},
	{
		path: dashboardPagesMenu.nocManagementPage.subMenu.expiredNocManagement.path,
		element: <NOC_MANAGEMENT_PAGE.NOC_EXPIRED_PAGE />,
	},
	// VEHICLE Management
	{
		path: dashboardPagesMenu.vehicleManagementPage.path,
		element: <VEHICLE_MANAGEMENT_PAGE.VEHICLE_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.vehicleManagementPage.subMenu.createVehicleManagement.path,
		element: <VEHICLE_MANAGEMENT_PAGE.VEHICLE_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.vehicleManagementPage.subMenu.updateVehicleManagement.path,
		element: <VEHICLE_MANAGEMENT_PAGE.VEHICLE_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.vehicleManagementPage.subMenu.detailVehicleManagement.path,
		element: <VEHICLE_MANAGEMENT_PAGE.VEHICLE_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.vehicleManagementPage.subMenu.expiringVehicleManagement.path,
		element: <VEHICLE_MANAGEMENT_PAGE.VEHICLE_EXPIRING_PAGE />,
	},
	{
		path: dashboardPagesMenu.vehicleManagementPage.subMenu.expiredVehicleManagement.path,
		element: <VEHICLE_MANAGEMENT_PAGE.VEHICLE_EXPIRED_PAGE />,
	},
	// INQUIRY Management
	{
		path: dashboardPagesMenu.inquiryManagementPage.path,
		element: <INQUIRY_MANAGEMENT_PAGE.INQUIRY_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.inquiryManagementPage.subMenu.createInquiryManagement.path,
		element: <INQUIRY_MANAGEMENT_PAGE.INQUIRY_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.inquiryManagementPage.subMenu.updateInquiryManagement.path,
		element: <INQUIRY_MANAGEMENT_PAGE.INQUIRY_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.inquiryManagementPage.subMenu.detailInquiryManagement.path,
		element: <INQUIRY_MANAGEMENT_PAGE.INQUIRY_DETAIL_PAGE />,
	},
	// ATTENDANCE_REQUEST_PAGE
	{
		path: dashboardPagesMenu.attendanceRequest.path,
		element: <ATTENDANCE_REQUEST_PAGE.ATTENDANCE_REQUEST_PAGE />,
	},
	// ATTENDANCE_MONTHLY_PAGE
	{
		path: dashboardPagesMenu.monthlyAttendance.path,
		element: <ATTENDANCE_MONTHLY_PAGE.ATTENDANCE_MONTHLY_PAGE />,
	},
	// ATTENDANCE_MONTHLY_REPORT_PAGE
	{
		path: dashboardPagesMenu.hrmPage.subMenu.attendance.subMenu.attendanceMonthlyReport.path,
		element: <ATTENDANCE_MONTHLY_REPORT_PAGE.ATTENDANCE_MONTHLY_REPORT_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.attendance.subMenu.attendanceMonthlyReport.subMenu
			.attendanceMonthlyReportDetail.path,
		element: <ATTENDANCE_MONTHLY_REPORT_PAGE.ATTENDANCE_MONTHLY_REPORT_PAGE_DETAIL />,
	},
	// REQUEST_MANAGEMENT_PAGE
	{
		path: dashboardPagesMenu.hrmPage.subMenu.attendance.subMenu.requestManagement.path,
		element: <REQUEST_MANAGEMENT_PAGE.REQUEST_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.attendance.subMenu.requestManagement.subMenu
			.createRequestManagement.path,
		element: <REQUEST_MANAGEMENT_PAGE.REQUEST_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.attendance.subMenu.requestManagement.subMenu
			.editRequestManagement.path,
		element: <REQUEST_MANAGEMENT_PAGE.REQUEST_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.hrmPage.subMenu.attendance.subMenu.requestManagement.subMenu
			.detailRequestManagement.path,
		element: <REQUEST_MANAGEMENT_PAGE.REQUEST_DETAIL_PAGE />,
	},
	// AI_PRODUCT_REPORT_PAGE
	{
		path: dashboardPagesMenu.aiReportPage.subMenu.productReportPage.path,
		element: <AI_REPORTS_PAGE.AI_PRODUCT_REPORT_PAGE />,
	},
	// AI_SITE_WISE_SUPPLIER_PAYMENT_INFO_REPORT_PAGE
	{
		path: dashboardPagesMenu.aiReportPage.subMenu.siteWiseSupplierPaymentInfoReportPage.path,
		element: <AI_REPORTS_PAGE.AI_SITE_WISE_SUPPLIER_PAYMENT_INFO_REPORT_PAGE />,
	},
	// AI_PRODUCT_PURCHASE_ANALYTICS_REPORT_PAGE
	{
		path: dashboardPagesMenu.aiReportPage.subMenu.getProductPurchaseAnalyticsReportPage.path,
		element: <AI_REPORTS_PAGE.AI_PRODUCT_PURCHASE_ANALYTICS_REPORT_PAGE />,
	},
	// DAYBOOK PAGE
	{
		path: dashboardPagesMenu.dayBookPage.path,
		element: <DAYBOOK_PAGE.DAYBOOK_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.dayBookPage.subMenu.detailDayBook.path,
		element: <DAYBOOK_PAGE.DAYBOOK_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.dayBookPage.subMenu.createDayBook.path,
		element: <DAYBOOK_PAGE.DAYBOOK_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.dayBookPage.subMenu.updateDayBook.path,
		element: <DAYBOOK_PAGE.DAYBOOK_CREATE_PAGE />,
	},
	// All Bills PAGE
	{
		path: dashboardPagesMenu.expensesAndBillsPage.path,
		element: <EXPENSES_PAGE.EXPENSES_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.expensesAndBillsPage.subMenu.detailExpenses.path,
		element: <EXPENSES_PAGE.EXPENSES_DETAIL_PAGE />,
	},
	{
		path: dashboardPagesMenu.expensesAndBillsPage.subMenu.createExpenses.path,
		element: <EXPENSES_PAGE.EXPENSES_CREATE_PAGE />,
	},
	{
		path: dashboardPagesMenu.expensesAndBillsPage.subMenu.updateExpenses.path,
		element: <EXPENSES_PAGE.EXPENSES_CREATE_PAGE />,
	},
	// Notification PAGE
	{
		path: dashboardPagesMenu.notificationPage.path,
		element: <NOTIFICATIONS_PAGE.NOTIFICATIONS_LIST_PAGE />,
	},
	{
		path: dashboardPagesMenu.notificationPage.subMenu.detailNotification.path,
		element: <NOTIFICATIONS_PAGE.NOTIFICATIONS_DETAIL_PAGE />,
	},
	/** ************************************************** */

	/**
	 * Pages
	 */

	/**
	 * Single Pages
	 */
	/**
	 * Single Pages
	 */

	/**
	 * List
	 */

	/**
	 * Grid
	 */

	/**
	 * Edit
	 */

	/**
	 * END - Pages
	 */

	/**
	 * Auth Page
	 */
	{
		path: demoPagesMenu.page404.path,
		element: <AUTH.PAGE_404 />,
	},
	{
		path: demoPagesMenu.login.path,
		element: <Login />,
	},
	{
		path: demoPagesMenu.forgotPassword.path,
		element: <ForgotPassword />,
	},
	{
		path: demoPagesMenu.changePassword.path,
		element: <ChangePassword />,
	},
	{
		path: demoPagesMenu.resetPassword.path,
		element: <ResetPassword />,
	},
	{
		path: demoPagesMenu.privacyPolicy.path,
		element: <PrivacyPolicy />,
	},
	{
		path: demoPagesMenu.termsAndCondition.path,
		element: <TermsAndCondition />,
	},
	{
		path: dashboardPagesMenu.updateCompanyProfilePage.path,
		element: <UpdateCompanyProfile />,
	},
	{
		path: demoPagesMenu.signUp.path,
		element: <Login isSignUp />,
	},

	/**
	 * App
	 */

	/**
	 * App > Project Management
	 */

	/**
	 * App > Knowledge
	 */

	/**
	 * App > Sales
	 */

	/**
	 * App > Appointment
	 */

	/**
	 * App > CRM
	 */

	/**
	 * App > Chat
	 */

	/**
	 * END - App
	 */

	/** ************************************************** */

	/**
	 * Page Layout Types
	 */
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.defaultAside.path,
		element: <PAGE_LAYOUTS.ASIDE />,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.minimizeAside.path,
		element: <PAGE_LAYOUTS.MINIMIZE_ASIDE />,
	},
];
const documentation: RouteProps[] = [
	/**
	 * Getting Started
	 */
	/**
	 * Routes
	 */
	/**
	 * Bootstrap
	 */
	/**
	 * Content
	 */
	/**
	 * Forms
	 */
	/**
	 * Components
	 */
	/**
	 * Utilities
	 */
	/**
	 * Extra
	 */
	/**
	 * Icons
	 */
	/**
	 * Charts
	 */
];
const contents = [...presentation, ...documentation];

export default contents;
